import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

export const getInboxOverTime = createAsyncThunk('inboxOverTime/getRequest', async (data) => {
    try {
        const response = await axios.post('/CorrectionInAttendance/get-request', data, {
            headers: { 'Content-Type': 'application/json' }
        });

        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateInboxOverTimeRemarks = createAsyncThunk('inboxOverTime/updateRemarks', async (data) => {
    try {
        const response = await axios.put('/CorrectionInAttendance/request-status/' + data?.id, data?.data, {
            headers: { 'Content-Type': 'application/json' }
        });

        toast.success(response?.data?.message || 'Status updated successfully.');
        return response?.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

const inboxOverTimeSlice = createSlice({
    name: 'inboxOverTime',
    initialState: {
        overTime: []
    },
    reducers: {
        removeInboxOverTime: (state) => {
            state.overTime = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInboxOverTime.fulfilled, (state, action) => {
            state.overTime = action?.payload;
        });
    }
});

export const { removeInboxOverTime } = inboxOverTimeSlice.actions;
export default inboxOverTimeSlice.reducer;
